import auth from "./auth";

export default {
  sockets: {
    connect () {
      console.log('--> socket connected', this.$socket);
    }
  },
  methods: {
    socket_connect () {
      // console.log('socket autoConnect: ',this.$socket.client.io.autoConnect);
      if (this.$socket.client.disconnected) {
        this.$socket.client.io.opts.auth = {
          authorization: 'Bearer ' + this.$auth.getToken(),
        };
        this.$socket.client.io.autoConnect = true;
        this.$socket.client.io.opts.query = {
          token: this.$auth.getToken(),
          role: this.user.role
        }
        this.$socket.client.open();
        //this.$socket.client.emit('online', this.user);
      } else {
        //console.log('socket already connected')
        //this.$socket.client.emit('online', this.user);
      }

    }
  },
  created () {
    // console.log('--> ================ socket created ================')
    this.socket_connect();
  },
  computed: {
    user: {
      cache: false,
      get () {
        return this.$store.getters.user
      }
    }
  }
}
